module.exports = __webpack_public_path__ + "img/Android4.5f13dee2.png";